export const isPageFromNull = (app) => app.page.from.meta.alias === undefined
